import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Flex, Img, useMediaQuery, useStyleConfig} from '@chakra-ui/react'
import {EditorialVideo} from '../../video'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {remCalc} from '../../../../theme/_utils'

export const TwoMedia = ({media1, media2}) => {
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(449)})`)
    const styles = useStyleConfig('Gallery')

    const damImage1 = useDamImage(media1?.image)
    const damImage2 = useDamImage(media2?.image)

    return (
        <Flex
            flexDirection={isMobile ? 'column' : 'row'}
            justifyContent={isMobile ? 'flex-start' : 'center'}
            alignItems={isMobile ? 'center' : 'flex-start'}
            gap={{base: remCalc(16), md: remCalc(24)}}
            className={'twoMediaLayout'}
        >
            {media1?.is_video ? (
                <EditorialVideo
                    data={media1?.video && media1?.video?.length ? media1?.video[0] : null}
                    data-testid="gallery-2-media"
                    {...styles.halfMedia}
                />
            ) : (
                (damImage1.url || media1?.image?.alt) && (
                    <AspectRatio
                        ratio={damImage1.ratio}
                        data-testid="gallery-2-media"
                        {...styles.halfMedia}
                    >
                        <Img src={damImage1.url} alt={media1?.image?.alt || ''} />
                    </AspectRatio>
                )
            )}
            {media2?.is_video ? (
                <EditorialVideo
                    data={media2?.video && media2?.video?.length ? media2?.video[0] : null}
                    data-testid="gallery-2-media"
                    {...styles.halfMedia}
                />
            ) : (
                (damImage2.url || media2?.image?.alt) && (
                    <AspectRatio
                        ratio={damImage2.ratio}
                        data-testid="gallery-2-media"
                        {...styles.halfMedia}
                    >
                        <Img src={damImage2.url} alt={media2?.image?.alt || ''} />
                    </AspectRatio>
                )
            )}
        </Flex>
    )
}

TwoMedia.propTypes = {
    media1: PropTypes.shape({
        is_video: PropTypes.bool,
        video: PropTypes.arrayOf(PropTypes.shape()),
        image: PropTypes.shape(),
    }),
    media2: PropTypes.shape({
        is_video: PropTypes.bool,
        video: PropTypes.arrayOf(PropTypes.shape()),
        image: PropTypes.shape(),
    }),
}
